/**
 * Runtime configuration — loaded from /config.json before the app boots, so a
 * deployed bundle can be re-pointed (client id / API base) without a rebuild.
 * Vite env vars act as fallbacks for local dev.
 */
export interface AppConfig {
  tenant_id: string;
  client_id: string;
  api_base: string;
}

let cfg: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cfg) return cfg;
  let fromFile: Partial<AppConfig> = {};
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (res.ok) fromFile = await res.json();
  } catch {
    // fall through to env
  }
  cfg = {
    tenant_id: fromFile.tenant_id || (import.meta.env.VITE_ENTRA_TENANT_ID as string) || "",
    client_id: fromFile.client_id || (import.meta.env.VITE_ENTRA_APP_CLIENT_ID as string) || "",
    api_base: (fromFile.api_base || (import.meta.env.VITE_API_BASE as string) || "").replace(/\/$/, ""),
  };
  return cfg;
}

export function config(): AppConfig {
  if (!cfg) throw new Error("Config not loaded yet");
  return cfg;
}

export function isAuthConfigured(): boolean {
  return Boolean(cfg?.client_id && cfg.client_id.length > 10);
}
